var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{class:_vm.$style.inputText,attrs:{"size":"mini","prefix-icon":"el-icon-search","placeholder":"Search in list","clearable":"","data-test-id":"gamesListFilterInput"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})
}
var staticRenderFns = []

export { render, staticRenderFns }